import IntruccionesSeleccionDeCamas from '../IntruccionesSeleccionDeCamasV2';
import React, { useState, useEffect } from 'react';
import Ajustadores from '../Ajustadores';
import VainillaDialog from '../../../../../sharecomponents/vanilladialog';
import { activeDialog } from '../../../../../../utils/Common';
import v from '../../../../../../utils/Verifiers';
import './ListadoBloquesValvulasV2.css';
import { da } from 'date-fns/locale';
import ListaPlanesItinerarioCama from './ListaPlanesItinerarioCama';

const ListadoBloquesValvulasV2 = (p) => {
    const data = { ...p.data };
    const bloqueo = data.inventariado;
    const ajustadores = new Ajustadores();
    const valvulas = JSON.parse(JSON.stringify(p.valvulas));
    const lenValvulas = valvulas.length;
    const [dialog, setdialog] = useState({ show: false });
    const [metros_camas, setmetros_camas] = useState([]);
    const [camaSeleccion, setcamaSeleccionada] = useState(null);
    const [camasPlan, setcamasPlan] = useState({});
    const [listaPlanes, setlistaPlanes] = useState(null);
    const [selecciones, setselecciones] = useState({ cama_inicio: data.cama_inicio, cama_fin: data.cama_fin, tunel: "", metros_inicio: data.metros_inicio, metros_fin: data.metros_fin });
    const [valvula, setvalvula] = useState({
        "camas": [],
        "camas_totales": 0,
        "valvula": "",
        "largo_cama": 0,
        "valvula_id": null,
        "bloquesLibres": []
    });
    const [coleccionCamas, setcoleccionCamas] = useState({ camas: [], camas_totales: 0, largo_cama: 0, valvula: "", valvula_id: p.data?.valvula_id });

    useEffect(() => {
        if (!data?.valvula_id || !data?.semana || !data?.dia) {
            setdialog({
                tipo: "error",
                show: true,
                title: "Información incompleta",
                body: "Seleccione la válvula, semana y día de trasplante para continuar. Estos datos son necesarios para poder cargar las camas disponibles para esa fecha. ",
                funct: () => { setdialog({ show: false }); p.close(); },
                size: 'm'
            });
        } else {
            getItinerarioCamasDia();
        }


    }, []);

    async function getItinerarioCamasDia() {
        const resp = await v.getDataAPI(`campo/v2/camas/${data?.valvula_id ?? '---'}/${data?.semana ?? '--'}/${data?.dia ?? '--'}/itinerario`, { plan_id: data?.planeacion_campo_id });
        if (!resp || !resp.estatus) return;
        setcoleccionCamas(resp.data);
        setvalvula(resp.data);
        setcamasPlan(resp.camas_plan ?? {});
        if (((Object.values(resp?.camas_plan ?? {})).length ?? 0) > 0) {
            const arrCamas = Object.values(resp.camas_plan);
            const inicio = arrCamas[0];
            const fin = arrCamas[arrCamas.length - 1];
            const sels = { ...selecciones };
            sels.cama_inicio = inicio.cama;
            sels.cama_fin = fin.cama;
            sels.metros_inicio = inicio.metros;
            sels.metros_fin = fin.metros;
            const selsModificados = ajustarDatosCamas(sels, false, resp.data.camas);
            setselecciones(selsModificados);
        } else {
            setselecciones({ cama_inicio: 0, cama_fin: 0, tunel: "", valvula: resp.data.valvula_id, metros_inicio: resp.data.largo_cama, metros_fin: resp.data.largo_cama });
        }

    }


    const ajustarDatosCamas = (sel = { ...selecciones }, avisoDesborde = true, valvulaCamas = valvula.camas) => {
        const reporte = ajustadores.revisarCamasSeleccionadas(valvulaCamas, sel.cama_inicio, sel.cama_fin, sel.metros_inicio, sel.metros_fin);
        const desbordantes = reporte.desbordantes.length;
        if (desbordantes > 0 && avisoDesborde) {

            v.activeDialog(setdialog, `se ${desbordantes === 1 ? 'encontró  una cama seleccionada que supera' : 'encontraron ' + desbordantes + " camas seleccionadas que superan"}  la capacidad disponible: ${reporte.desbordantes.join(" , ")}.`, "Se encontraron problemas, conciderelos antes de continuar");
        }

        sel.valvula = valvula.valvula_id;
        sel.tunel = reporte.tunel;
        sel.metros_totales = reporte.metros_totales;
        setcamasPlan(reporte.camas ?? {});
        return sel;
    }

    /**
     * Evalua la cama inicio o final, y de acuerdo al valor de la cama seleccionada se debe ajustar el valor de la cama_inicio o cama_fin ejemplo, supona que actualmente tenemos
     * EJEMPLO1 : cama_inicio = 3, cama_fin = 7, tipoCamaNuevo = cama_inicio, valor = 9, en este caso se debe ajustar la cama_inicio a 9 y la cama_fin a 0
     * EJEMPLO2 : cama_inicio = 3, cama_fin = 7, tipoCamaNuevo = cama_fin, valor = 1, en este caso se debe ajustar la cama_inicio a 0 y la cama_fin a 1
     * EJEMPLO3 : cama_inicio = 3, cama_fin = 7, tipoCamaNuevo = cama_inicio, valor = 1, en este caso se debe ajustar la cama_inicio a 1 y la cama_fin a 7
     * @param {number} inicioActual valor de la cama_inicio actual en la variable de selecciones
     * @param {number} finActual Valor de la cama_fin actual en la variable de selecciones
     * @param {number} tipoCamaNuevo Tipo seleccionado al hacer click en alguno de los botones de cama_inicio o cama_fin
     * @param {number} valor Valor actual que se va a asignar a la cama_inicio o cama_fin
     * @returns {Object} Objeto con las nuevas camas_inicio y cama_fin ajustadas
     */
    const ajustarOrdenCamaInicioFin = (inicioActual, finActual, tipoCamaNuevo, valor) => {
        if (tipoCamaNuevo === 'cama_inicio') {
            if (finActual > 0 && finActual < valor) return { cama_inicio: valor, cama_fin: 0 };
            return { cama_inicio: valor, cama_fin: finActual };
        } else {
            if (inicioActual > 0 && inicioActual > valor) return { cama_inicio: 0, cama_fin: valor };
            return { cama_inicio: inicioActual, cama_fin: valor };
        }
    }

    const clickONCamaInicioOcamaFin = (tipo) => {
        if (camaSeleccion === null) return;
        let camas_ajustadas = ajustarOrdenCamaInicioFin(selecciones.cama_inicio, selecciones.cama_fin, tipo, camaSeleccion);
        let sel = { ...selecciones, ...camas_ajustadas };

        if ((sel.cama_inicio ?? 0) > 0 && (sel.cama_fin ?? 0) > 0) {
            sel = ajustarDatosCamas(sel);
        }

        setselecciones(sel);
        setcamaSeleccionada(null);
    };

    const revisarBloquesContinuos = (sel, valv = { ...valvula }) => {
        let bloques = valv.bloquesLibres;
        for (let i = 0; i < bloques.length; i++) {
            if (bloques[i].inicio <= sel.cama_inicio && bloques[i].fin >= sel.cama_fin) return true;
        }
        return false;
    }

    const ajustarMmtros = (e) => {
        let { name, value } = e.target;
        value = +value;
        if (isNaN(value) || value <= 0 || value > valvula.largo_cama) value = valvula.largo_cama;

        const sels = { ...selecciones };
        sels[name] = value;
        if (sels.cama_inicio && sels.cama_fin) {
            setselecciones(ajustarDatosCamas(sels, false));
            return;
        }
        setselecciones(sels);
    }

    /**
     * Deacuerdo a las camas seleccionadas si se está seleccionando una cama ajusta el color de las casillas de las camas
     * @param {number} index indice de la cama que se va a evaluar su color 
     * @returns {string} clase de color para la cama
     */
    const colorCasilla = (index) => {
        //Si hay una camas seleccionada, implica que el sistema se encuentra en estado de seleccion y es necesario resaltar esa cama entre las demas
        //conseguimos esto alterando la opaciodad de elementos no seleccionados
        let opacidad = camaSeleccion !== null && camaSeleccion !== index ? " opacity-40 " : "";
        if (metros_camas[index].porcentaje >= 100) return opacidad + ' bg-dark text-white border border-danger ';
        return (colorCama(index) + "  " + (metros_camas[index].porcentaje > 0 ? " border-warning border-2 " : "") + opacidad);
    }

    /**
    * De acuerdo a si ya se seleciono la cama de inicio y fin determina si esta cama pertenece al grupo de camas seleccionadas, decide si se debe colorear de amarillo o no.
    * @param {number} index 
    * @returns {string} clase de color para la cama
    */
    const colorCama = (camaNumero) => {
        if (camaSeleccion) {
            return camaSeleccion !== camaNumero ? "rgb(243, 242, 242)" : "rgba(146, 234, 88, 0.86)";
        }
        if ((selecciones.cama_inicio ?? 0) < 1 || (selecciones.cama_fin ?? 0) < 1) {
            if (selecciones.cama_inicio === camaNumero || selecciones.cama_fin === camaNumero) return "rgb(255, 169, 119)";
            return "rgb(243, 242, 242)";
        }
        if (selecciones.cama_inicio <= camaNumero && selecciones.cama_fin >= camaNumero) return "rgb(255, 236, 92)";
        return "rgb(243, 242, 242)";
    }

    const camaValores = (cama) => {
        if (camasPlan[cama.cama]) {
            return camasPlan[cama.cama];
        }
        return cama;
    }

    return (
        <>
            <div className='vh-100 dosis vw-100 p-2 overflow blur-l bg-white3' style={{ position: "fixed", top: 0, left: 0, zIndex: 999 }}>
                <div className='row justify-content-evenly w-100 m-0 p-0' style={{ position: "relative" }}>
                    <div className='w-100 m-2 text-end'>
                        <button className='btn btn-danger mt-2 shadow ps-5 pe-5 round-xxl' onClick={p.close}>Cerrar</button>
                    </div>
                    <div className='bg-light shadow-multi round-m m-0 p-2' style={{ width: "100%", maxWidth: "1800px" }}>

                        <div className='row justify-content-evenly w-100 m-0 p-0'>
                            <IntruccionesSeleccionDeCamas valvula={valvula} metros={data.metros} />
                            <div className='w-100 m-0 p-0'>
                                <div className='grid-valvula m-0 col-lg-12' >
                                    {coleccionCamas.camas.map((cama, i) => <div className='col-lg-12 m-1 mb-2 p-1 cama-contenedor' key={'camalista' + cama.cama}>
                                        <div className='row justify-content-evenly align-items-center w-100 m-0 p-0 mb-1'>
                                            <div className='col-lg-12 contenedor-ocupacion-cama m-0 p-0' style={{ color: cama.ocupado_porcentaje >= 1 ? 'rgb(254, 254, 254)' : 'rgb(0, 0, 0)', }}>
                                                {camasPlan[cama.cama] && <div className='col-lg-12 border' style={{
                                                    position: 'absolute',
                                                    borderRadius: cama.ocupado_porcentaje >= 1 ? '0' : '0 5px 5px 0',
                                                    top: 0,
                                                    left: 0,
                                                    width: `${Math.min(camasPlan[cama.cama].ocupado_porcentaje * 100, 100)}%`,
                                                    height: '100%',
                                                    backgroundColor: "rgb(171, 242, 246)",
                                                }}></div>}
                                                <div className='col-lg-12 border' style={{
                                                    position: 'absolute',
                                                    borderRadius: cama.ocupado_porcentaje >= 1 ? '0' : '0 5px 5px 0',
                                                    top: 0,
                                                    left: 0,
                                                    width: `${Math.min(cama.ocupado_porcentaje * 100, 100)}%`,
                                                    height: '100%',
                                                    zIndex: 1,
                                                    backgroundColor: cama.ocupado_porcentaje > 1 ? "rgb(131, 11, 0)" : (cama.ocupado_porcentaje == 1 ? 'rgb(0, 0, 0)' : 'rgb(251, 188, 1)')
                                                }}></div>
                                                <span className='p-1 bg-white5 round-m' style={{ zIndex: 1 }}>{camaValores(cama).cama}</span>
                                                <span className='text-s text-300 m-0 ms-2 text-xs bg-white5 round-m p-1' style={{ zIndex: 1 }}>
                                                    {Math.max(0, Math.round((valvula.largo_cama - camaValores(cama).ocupado_metros) * 100) / 100)}m.
                                                </span>
                                                <span className='text-s text-300 m-0 ms-2 text-xs bg-white5 round-m p-1' style={{ zIndex: 1 }}>
                                                    {+(Math.round(camaValores(cama).ocupado_porcentaje * 10000) / 100).toFixed(2)}%
                                                </span>

                                            </div>
                                            <div
                                                onClick={() => {
                                                    if (cama.ocupado_porcentaje >= 1) return;
                                                    camaSeleccion === cama.cama ? setcamaSeleccionada(null) : setcamaSeleccionada(cama.cama)
                                                }}
                                                className='boton-seleccionar-cama shadow-press m-0 col-lg-12 mb-1 p-0'
                                                style={{ textDecoration: 'italic', backgroundColor: colorCama(cama.cama), cursor: cama.ocupado_porcentaje >= 1 ? 'not-allowed' : 'pointer' }}
                                            >
                                                {cama.ocupado_porcentaje > 1 ? 'DESBORDADA' : (cama.ocupado_porcentaje == 1 ? 'LLENA' : 'SELECCIONAR')}
                                            </div>

                                            {cama.planes.length > 0 && <div className='boton-ver-planes shadow-press col-lg-12 p-0 text-bold' onClick={() => setlistaPlanes(cama)} >
                                                <span className='text-300 me-2'>{cama.planes.length}</span> PLANES
                                            </div>}
                                        </div>

                                    </div>)
                                    }
                                </div>
                            </div>
                            <div className='w-100 mt-3'></div>
                            <div
                                className={`bw-200 round-s p-3 m-1 shadow contenedor text-bold h3 border border-2 
                                ${camaSeleccion !== null ? "scale-continue-05 pointer" : ""}
                                ${!camaSeleccion && selecciones.cama_inicio > 0 ? 'border-dark bg-warning' : ' border-danger'} `}
                                onClick={() => clickONCamaInicioOcamaFin('cama_inicio')}
                            >
                                {/*El numero de cama solo aparece si no se está en moodo selección y si ya hay una cama de inicio seleccionada */}
                                Cama inicio {!camaSeleccion && selecciones.cama_inicio > 0 && <span className='text-bold ms-3'>{selecciones.cama_inicio}</span>}
                            </div>
                            <div
                                className={`bw-200 round-s p-3 m-1 shadow contenedor text-bold h3 border border-2
                                ${camaSeleccion !== null ? "scale-continue-05 pointer" : ""}
                                ${!camaSeleccion && selecciones.cama_fin > 0 ? 'border-dark bg-warning' : ' border-danger'}`}
                                onClick={() => clickONCamaInicioOcamaFin('cama_fin')}
                            >
                                Cama fin {!camaSeleccion && selecciones.cama_fin > 0 && <span className='text-bold ms-3'>{selecciones.cama_fin}</span>}
                            </div>
                            {selecciones.cama_inicio > 0 && selecciones.cama_fin > 0 && <>
                                <div className='w-100'></div>
                                <div className='bw-200 mt-2'>
                                    <div className='w-100 text-sartat text-bold text-s'>Metros utilizados en cama inicial</div>
                                    <input type='number' className='form-control form-control-sm' value={selecciones.metros_inicio} name='metros_inicio' onChange={ajustarMmtros} />
                                </div>
                                <div className='bw-200 mt-2'>
                                    <div className='w-100 text-sartat text-bold text-s'>Metros utilizados en cama final</div>
                                    <input type='number' className='form-control form-control-sm' value={selecciones.metros_fin} name='metros_fin' onChange={ajustarMmtros} />
                                </div>
                            </>}
                            <div className='w-100 mb-3 p-2 text-center'>
                                {selecciones.tunel && <div className='text-bold text-m w-100 mt-0 mb-0'>Números de tuneles:<span className='ms-3 text-l text-300'>{selecciones.tunel}</span></div>}
                                {selecciones.tunel && <div className='text-bold text-m w-100 mt-0 mb-0'>
                                    Camas seleccionadas:<span className='ms-3 text-l text-300 me-2'>{selecciones.cama_fin - selecciones.cama_inicio + 1}</span>,
                                    metros totales <span className='ms-3 text-l text-300 me-2'>{(+(selecciones.metros_totales ?? 0).toFixed(2))}</span>
                                </div>}
                            </div>

                            <div className='bw-200'>
                                <button className='btn btn-sm btn-danger round-xl shadow' onClick={() => {
                                    setselecciones({ cama_inicio: 0, cama_fin: 0, tunel: "", valvula: valvula.valvula_id, metros_inicio: valvula.largo_cama, metros_fin: valvula.largo_cama });
                                    setcamasPlan({});
                                }} >Borrar selecciones</button>
                            </div>

                            <div className='bw-300'>
                                <button className='w-100 btn btn-sm btn-dark round-xl round-xl shadow text-bold'
                                    disabled={selecciones.cama_inicio < 1 || selecciones.cama_fin < 1}
                                    onClick={() => p.save(selecciones, data.index, data.subindex)}
                                >Guardar camas</button>
                            </div>


                            <div className='w-100 mb-3'></div>

                        </div>
                    </div>
                </div>
            </div>
            <VainillaDialog data={dialog} />
            {listaPlanes && <ListaPlanesItinerarioCama cama={listaPlanes} close={() => setlistaPlanes(null)} />}
        </>


    )
}

export default ListadoBloquesValvulasV2;